import { useLanguage } from '../i18n/LanguageContext';
import type { ShareCardAspect } from '../utils/shareCardHelpers';

export interface QuizShareAspectPickerProps {
  value: ShareCardAspect;
  onChange: (aspect: ShareCardAspect) => void;
  tone?: 'gold' | 'ice';
}

const OPTIONS: ShareCardAspect[] = ['story', 'feed'];

export default function QuizShareAspectPicker({
  value,
  onChange,
  tone = 'gold',
}: QuizShareAspectPickerProps) {
  const { m } = useLanguage();
  const labels = m.share.aspectPicker;

  return (
    <div className={`quiz-share-aspect-picker quiz-share-aspect-picker--${tone}`}>
      <span className="quiz-share-aspect-label">{labels.label}</span>
      <div className="quiz-share-aspect-options" role="radiogroup" aria-label={labels.ariaLabel}>
        {OPTIONS.map((aspect) => {
          const spec = labels[aspect];
          const selected = value === aspect;
          return (
            <button
              key={aspect}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`quiz-share-aspect-btn${selected ? ' quiz-share-aspect-btn--active' : ''}`}
              onClick={() => onChange(aspect)}
            >
              <span className="quiz-share-aspect-btn-ratio">{spec.ratioLabel}</span>
              <span className="quiz-share-aspect-btn-platform">{spec.platformLabel}</span>
              <span className="quiz-share-aspect-btn-size">{spec.exportLabel}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}